module.exports = __webpack_public_path__ + "static/img/success.1f72f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success.png
// module id = mzrL
// module chunks = 21